import { styled, Typography } from '@mui/material';

export default styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  maxHeight: '100%',
  maxWidth: '100%'
}));
